import React, { useEffect, useState } from 'react'
import { Card, CARD_THEME, CircularLoader } from '@st-operations/uikit/src/v2/index.js'

import { logErrorAsync } from '_lib/utility.js'
import { getGeoCountryStatistics, getDistribution } from '_services/data-explorer'

import { useEventFeedsContext } from '../../context/index.jsx'
import { MAPPED_EVENT } from '../scale-and-coverage/constants'
import './styles.scss'
import GeographicalRegions from './geographical-regions/index.jsx'
import MappedEvents from './mapped-events/index.jsx'
import { useIsSnapshot } from '../../manage-component/index.jsx'
import DeviceTypes from '../device-types/index.jsx'

export const formatDistributionEventTypeData = (dataArray) => {
  const newDistributionArray = dataArray
    .filter((item) => MAPPED_EVENT[item.eventType])
    .map((item) => {
      const roundedPercent = Math.round(item.percent * 100)
      return {
        ...item,
        eventType: MAPPED_EVENT[item.eventType],
        percent: roundedPercent,
        percentText: `${roundedPercent}%`,
      }
    })

  return newDistributionArray.sort((itemA, itemB) => itemB.size - itemA.size)
}

export const formatDistributionRegionData = (dataArray) => {
  const newDistributionArray = dataArray.map((item) => {
    const roundedPercent = Math.round(item.percent * 100)
    return {
      ...item,
      percent: roundedPercent,
      percentText: `${roundedPercent}%`,
    }
  })

  return newDistributionArray
}

const Distribution = () => {
  const { data, id } = useEventFeedsContext()
  const [loading, setLoading] = useState(false)
  const [eventTypes, setEventTypes] = useState([])
  const [topRegions, setTopRegions] = useState([])
  const [topCountries, setTopCountries] = useState([])
  const [deviceTypes, setDeviceTypes] = useState([])
  const isSnapshot = useIsSnapshot()

  useEffect(() => {
    async function getData() {
      setLoading(true)
      const requestConfig = {
        attributes: data.attributes,
        filters: data.filters,
        aggregations: data.aggregations,
      }

      try {
        const distribution = isSnapshot
          ? data.snapshot.distribution
          : await getDistribution(requestConfig)
        setEventTypes(formatDistributionEventTypeData(distribution.eventTypes))
        setTopRegions(formatDistributionRegionData(distribution.regions))
        setDeviceTypes(distribution.deviceTypes)
        const geo = isSnapshot
          ? data.snapshot.geoCountryStatistics
          : await getGeoCountryStatistics(requestConfig)
        setTopCountries(Object.values(geo?.countries, {}))
      } catch (error) {
        logErrorAsync(error)
        toast.error(error.message)
      }
      setLoading(false)
    }

    if (data._id || id === 'discovery') {
      getData()
    }
  }, [data.filters])

  return (
    <section className="scale-and-coverage__container">
      <If condition={loading}>
        <CircularLoader className="scale-and-coverage__loader" />
      </If>
      <If condition={!loading}>
        <div className="de-events__distribution">
          <If condition={eventTypes}>
            <div>
              <Card className="de-events__distribution-card" theme={CARD_THEME.NO_SHADOW}>
                <h3 className="de-events__distribution-card-title">Mapped Event</h3>
                <MappedEvents data={eventTypes} />
              </Card>
              <Card
                className="de-events__distribution-card de-events__distribution-card--types"
                theme={CARD_THEME.NO_SHADOW}
              >
                <h3 className="de-events__distribution-card-title">Device Types</h3>
                <DeviceTypes types={deviceTypes} />
              </Card>
            </div>
          </If>
          <If condition={topRegions}>
            <Card
              className="de-events__distribution-card de-events__distribution-card--region"
              theme={CARD_THEME.NO_SHADOW}
            >
              <h3 className="de-events__distribution-card-title">Geographical Regions</h3>
              <GeographicalRegions
                topCountriesData={topCountries}
                distributionRegionData={topRegions}
                disableClick
              />
            </Card>
          </If>
        </div>
      </If>
    </section>
  )
}

export default React.memo(Distribution)
